import DashboardRoutes from './modules/dashboard'
import SystemSettingsRoutes from './modules/system-settings'
import StakeholderRoutes from './modules/stakeholders'
import ProductTypeRoutes from './modules/product-types'
import TitleListRoutes from './modules/title-lists'
import LicenseRoutes from './modules/licenses'
import MetaDataCategoryRoutes from './modules/meta-data-categories'
import MetaDataFieldRoutes from './modules/meta-data-fields'
import { autoImportRoutes } from './auto-import-routes'

const routes = autoImportRoutes()

export default [
  {
    path: '/',
    name: 'root',
    redirect: '/dashboard'
  },
  ...DashboardRoutes,
  ...SystemSettingsRoutes,
  ...MetaDataCategoryRoutes,
  ...MetaDataFieldRoutes,
  ...StakeholderRoutes,
  ...ProductTypeRoutes,
  ...TitleListRoutes,
  ...LicenseRoutes,
  ...routes.flat()
]
